import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a300449e&scoped=true&lang=css"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a300449e"]])

export default __exports__